import React from "react";

function TimelineInfo({ event, place }) {
  return (
    <div className="bg-primary-dark p-4 rounded-md shadow-sm">
      <h6 className="font-secondary font-semibold text-secondary-dark text-sm lg:text-lg">
        {event}
      </h6>
      <p className="opacity-90 text-xs mt-2 lg:mt-1 lg:text-md text-white">
        {place}
      </p>
    </div>
  );
}

export default TimelineInfo;
